// @vendors
import { useContext, useMemo } from 'react'
import { useHistory } from 'react-router-dom';
import {
  Box,
  Button,
  ClearAllIcon,
  Grid,
  IconButton,
  InputAdornment,
  SearchRoundedIcon,
  TextField,
  Toolbar,
  Tooltip,
  Typography
} from "../../../components/shared/MaterialUI";

// @assets
import { StyleAPiClient } from '../StyleApiClient';
import { EmployeeTableStyles } from '../../../assets/css/employeeTable-style';
import { theme } from '../../../assets/theme';
import { GeneralStyles } from '../../../assets/css/general-style';

// @constants
import { ROUTENAME } from '../../../navigation/RouteName';

// @state
import { ClientContext } from '../ApiClients';

const ToolbarClients = ({openModalCreate}) => {

    const styles = useMemo(() => StyleAPiClient(), []);
    const generalStyle = useMemo(() => GeneralStyles(), []);
    const styleInput = useMemo(() => EmployeeTableStyles(),[]);
    const history = useHistory();
    const {
        rowsState,
        getAllClients,
        setRowsState,
    } = useContext(ClientContext);

    const handleSearchBar = async (query) => {
        if (query) getAllClients();
    };

    const onSearchBarChange = (e) => {
        setRowsState((current) => ({
            ...current,
            filters: {name: e.target.value}
        }));
    };

   const clearSearch = () => {
        setRowsState((prev) => ({
            ...prev,
            filters: {name: ""}
        }));
        getAllClients({filters: {}});
    };

    const actionToSelect = () => {
        if(rowsState.filters?.name === '')return clearSearch();
        if(rowsState.filters?.name?.length > 0)return handleSearchBar(rowsState.filters?.name);
        return
    }

  return (
    <Toolbar sx={styles.toolbar}>
        <Box sx={styles.header}>
          <Grid
            container
            direction="row"
            alignItems="center"
            spacing={2}
          >
            <Grid item xs={2} md={2} lg={1}>
              <Typography
                sx={{
                  fontSize: { xs: "20px", md: "23px" },
                  fontWeight: "bold",
                  color: theme.palette.primary.black
                }}
              >
                Api list
              </Typography>
            </Grid>

            <Grid
              item xs={10} md={6} lg={5}
              sx={{display: 'flex', gap: '10px', alignItems: 'center'}}
            >
              <TextField
                sx={{
                  ...styleInput.searchInput,
                  ...generalStyle.customButtonSm,
                  padding: 0,
                  color: theme.palette.secondary.black,
                }}
                value={rowsState?.filters?.name}
                id="outlined-client"
                placeholder="Search"
                onChange={(e) => onSearchBarChange(e)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    if(rowsState.filters?.name === '') return clearSearch()
                    return handleSearchBar(rowsState.filters?.name);
                  }
                }}
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <IconButton onClick={actionToSelect} sx={generalStyle.iconButtonSearch}>
                        <SearchRoundedIcon  />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <Tooltip title="Clear filter">
                <IconButton
                  onClick={() => clearSearch()}
                  sx={generalStyle.iconButtonSearch}
                >
                  <ClearAllIcon />
                </IconButton>
              </Tooltip>
            </Grid>
            
            <Grid item xs={12} sm={6} md={3} lg={3}>
              <Button
                color="inherit"
                onClick={() => history.push(ROUTENAME.dashboard)}
                sx={{...generalStyle.customButton, ...generalStyle.customButtonSm}}
              >
                Return To Dashboard
              </Button>
            </Grid>
            
            <Grid item xs={12} sm={6} md={3} lg={3}>
              <Button
                color="inherit"
                onClick={() => openModalCreate()}
                sx={generalStyle.customButtonMain}
              >
                Add api client
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Toolbar>
  )
}

export default ToolbarClients